import { a as __makeTemplateObject, d as __extends, _ as __assign, b as __spreadArray } from './tslib.es6-86dc5b0c.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Component } from 'react';
import styled from 'styled-components';
import { a as largeQuery } from './breakpoints-70e05b67.js';

var Fieldset = styled.fieldset(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 0;\n  line-height: 0;\n  margin: 0;\n  padding: 0;\n"], ["\n  border: 0;\n  line-height: 0;\n  margin: 0;\n  padding: 0;\n"])));
Fieldset.displayName = 'Fieldset';
var Pill = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-radius: 24px;\n  cursor: pointer;\n  display: inline-block;\n  padding: 11px 16px;\n  text-align: center;\n  user-drag: none;\n  user-select: none;\n\n  ", "\n\n  ", "\n"], ["\n  border-radius: 24px;\n  cursor: pointer;\n  display: inline-block;\n  padding: 11px 16px;\n  text-align: center;\n  user-drag: none;\n  user-select: none;\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n  background-color: " + theme.bottomBackgroundColor + ";\n  border: 1px solid " + theme.pillBoxSelectedBackgroundColor + ";\n  box-shadow: 0 0 5px -5px " + theme.pillBoxSelectedBackgroundColor + ";\n  color: " + theme.pillBoxForegroundColor + ";\n    transition: background-color " + theme.transitionDurationPrimary + " ease,\n      box-shadow " + theme.transitionDurationPrimary + "  ease,\n      color " + theme.transitionDurationPrimary + "  ease;\n  ";
}, function (_a) {
    var size = _a.size, theme = _a.theme;
    switch (size) {
        case 'small':
            return "\n          font: 15px/18px " + theme.fontFamilyPrimary + ";\n          min-width: 110px;\n          padding: 9px 15px;\n        ";
        case 'medium':
        default:
            return "\n          font: 18px/25px " + theme.fontFamilyPrimary + ";\n          min-width: 120px;\n          padding: 11px 16px;\n\n          @media " + largeQuery + " {\n            padding: 11px 20px;\n          }\n        ";
    }
});
Pill.displayName = 'Pill';
var Input = styled.input(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  left: -9999px;\n  position: absolute;\n\n  ", "\n"], ["\n  left: -9999px;\n  position: absolute;\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return "\n    &:checked {\n      + " + Pill + " {\n        background-color: " + theme.pillBoxSelectedBackgroundColor + ";\n        color: " + theme.pillBoxSelectedForegroundColor + ";\n      }\n    }\n\n    &:focus {\n      + " + Pill + " {\n        box-shadow: 0 0 5px 0\n          " + theme.pillBoxSelectedBackgroundColor + ";\n      }\n    }\n  ";
});
Input.displayName = 'Input';
var Label = styled.label(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: inline-block;\n  margin: 9px 10px 0 0;\n\n  ", "\n"], ["\n  display: inline-block;\n  margin: 9px 10px 0 0;\n\n  ", "\n"])), function (_a) {
    var isDisabled = _a.isDisabled;
    return "\n    opacity: " + (isDisabled ? 0.3 : 1) + "};\n  ";
});
Label.displayName = 'Label';
var Title = styled.legend(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  letter-spacing: 0.1px;\n  margin: 0;\n  text-align: ", ";\n  text-transform: uppercase;\n  width: 100%;\n\n  ", "\n"], ["\n  letter-spacing: 0.1px;\n  margin: 0;\n  text-align: ", ";\n  text-transform: uppercase;\n  width: 100%;\n\n  ", "\n"])), function (props) { return props.titleAlign; }, function (_a) {
    var theme = _a.theme;
    return "\n    color: " + theme.bottomForegroundPrimary + ";\n    font: 600 13px/16px " + theme.fontFamilyPrimary + ";\n  ";
});
Title.displayName = 'Title';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

// We keep track of the number of components created as a simple means of
// creating unique ids
var pillGroupCount = 0;
/**
 * A group of pill buttons that can represent one or multiple values
 */
var PillGroup = /** @class */ (function (_super) {
    __extends(PillGroup, _super);
    function PillGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (event) {
            var _a = _this.props, onChange = _a.onChange, currentValue = _a.value;
            var _b = event.currentTarget, checked = _b.checked, inputValue = _b.value;
            if (!Array.isArray(currentValue)) {
                if (onChange) {
                    onChange(event, inputValue);
                }
            }
            else {
                var nextValue = void 0;
                if (checked) {
                    nextValue = __spreadArray(__spreadArray([], currentValue, true), [inputValue], false);
                }
                else {
                    nextValue = currentValue.filter(function (optionValue) { return inputValue !== optionValue; });
                }
                if (onChange) {
                    onChange(event, nextValue);
                }
            }
        };
        pillGroupCount++;
        _this.name = "PillGroup-" + pillGroupCount;
        return _this;
    }
    PillGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, options = _a.options, _b = _a.size, size = _b === void 0 ? 'medium' : _b, title = _a.title, titleAlign = _a.titleAlign, _c = _a.value, currentValue = _c === void 0 ? '' : _c;
        var isRadio = typeof currentValue === 'string';
        var inputType = isRadio ? 'radio' : 'checkbox';
        return (jsxs(Fieldset, __assign({ className: className }, { children: [title && jsx(Title, __assign({ titleAlign: titleAlign }, { children: title }), void 0), options.map(function (_a) {
                    var isDisabled = _a.isDisabled, key = _a.key, label = _a.label, optionValue = _a.value;
                    var isChecked = false;
                    if (currentValue) {
                        if (typeof currentValue === 'string') {
                            isChecked = currentValue === optionValue;
                        }
                        else if (typeof currentValue === 'object') {
                            isChecked = currentValue.indexOf(optionValue) !== -1;
                        }
                    }
                    return (jsxs(Label, __assign({ isDisabled: !!isDisabled }, { children: [jsx(Input, { checked: isChecked, disabled: !!isDisabled, name: _this.name, onChange: _this.handleChange, type: inputType, value: optionValue }, void 0), jsx(Pill, __assign({ size: size }, { children: label }), void 0)] }), key + "-" + optionValue));
                })] }), void 0));
    };
    return PillGroup;
}(Component));

export { PillGroup as P };
